/*
 * @Description: 
 * @Author: yimengqi
 * @Date: 2020-08-31 16:08:33
 * @LastEditors: yimengqi
 * @LastEditTime: 2021-05-10 13:16:10
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// require('!style-loader!css-loader!less-loader!./assets/style.less')
import './assets/style.less'
import axios from 'axios'
import qs from 'qs'
import echarts from 'echarts'
import 'echarts-wordcloud/dist/echarts-wordcloud'
import 'echarts-wordcloud/dist/echarts-wordcloud.min'
import loading from './components/loading'
import loadingIcon from './components/loadingIcon'
import loadingInDialog from './components/loadingInDialog'
import aside from './components/aside'
import dialogContext from './components/dialogContext'

Vue.use(ViewUI);
Vue.use(qs);

//路由拦截
let myAxios = axios.create({});
myAxios.interceptors.response.use(res => {
  let code = res.data.code
  switch (code) {
    case 401: 
      //用户未登录，跳转至首页
      router.push("/");
      break
  }
  return res
})

Vue.prototype.$qs = qs;
Vue.prototype.$ajax = myAxios;
Vue.prototype.echarts = echarts;
Vue.prototype.$env = {
  domain: document.domain == 'yq.r360data.com' ? 'yq' : 'normal'
}

Vue.config.productionTip = false

Vue.component(
  'loading', loading
)
Vue.component(
  'loadingIcon', loadingIcon
)
Vue.component(
  'loadingInDialog', loadingInDialog
)
Vue.component(
  'myaside', aside
)
Vue.component(
  'dialogContext',dialogContext
)

//定义全局函数
Vue.prototype.toLogin =  ()=> {
  //跳转到登录页
  router.push("/");
}

Vue.prototype.getLocalStorage = (key)=>{
  if(!localStorage.getItem(key)){
    //跳转到登录页
    router.push("/");
    return "";
  }else{
    return localStorage.getItem(key);
  }
}

//将时间戳转化为yyyy-mm-dd格式的字符串
Vue.prototype.formatDate = function (timeStamp) {
  return `${new Date(timeStamp).getFullYear()}-${(
    new Date(timeStamp).getMonth() +
    1 +
    ""
  ).padStart(2, "0")}-${(
    new Date(timeStamp).getDate() + ""
  ).padStart(2, "0")}`
}

//将时间戳转化为hh-mm-ss格式的字符串
Vue.prototype.formatTime = function (timeStamp) {
  return `${(
    new Date(timeStamp).getHours() + ""
  ).padStart(2, "0")}:${(
    new Date(timeStamp).getMinutes() + ""
  ).padStart(2, "0")}:${(
    new Date(timeStamp).getSeconds() + ""
  ).padStart(2, "0")}`
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
